//! @ngInject
export function updateCaregiverHireDateModalCtrl($scope, $uibModalInstance) {

    $scope.closeModal = function (result) {
        if (!result) {
            result = 'ok';
        }
        $uibModalInstance.close(result);
    };
};